import { type TaskCriticalityEnum } from 'src/graphql/schema';
import { cn } from 'src/lib/utils';
import { CRITICALITY_CONFIG } from 'src/shared/mappings/criticality';

type Props = {
  criticality: TaskCriticalityEnum;
  className?: string;
  iconClassName?: string;
};

const CriticalityIcon = ({ criticality, className, iconClassName }: Props) => {
  const { icon: Icon, iconWrapperClassName } = CRITICALITY_CONFIG[criticality];

  return (
    <span
      className={cn('flex size-8 shrink-0 items-center justify-center rounded-lg', iconWrapperClassName, className)}
    >
      <Icon className={cn('size-4', iconClassName)} />
    </span>
  );
};

export default CriticalityIcon;
